import ApiService from "@/core/services/api.service";

let url = process.env.VUE_APP_API_ADMIN;

class ProcessManager {
  get(
    id,
    flat = false,
    optionalHeaders = {},
    disableAbort = false,
    fields = []
  ) {
    let params = {};
    if (flat) {
      params["flat"] = true;
    }
    if (fields.length > 0 && Array.isArray(fields)) {
      for (const [index, field] of fields.entries()) {
        params["_fields[" + index + "]"] = field;
      }
    }

    const urlSearchParams = params
      ? new URLSearchParams(params).toString()
      : "";

    return ApiService.get(
      url,
      "processes/" + id + "?" + urlSearchParams,
      optionalHeaders,
      disableAbort
    );
  }

  getAll(params, flat = false) {
    let options = "?";
    if (params.page) {
      options += "&page=" + params.page;
    }
    if (params.perPage) {
      options += "&perPage=" + params.perPage;
    }
    if (params.searchTerm) {
      options += "&searchTerm=" + params.searchTerm;
    }
    if (flat) {
      options += "&flat=1";
    }
    if (params.project_id !== undefined) {
      options += "&project_id=" + params.project_id;
    }
    if (params.no_project) {
      options += "&no_project=1";
    }
    if (params.for_client) {
      options += "&for_client=1";
    }

    if (params.projects) {
      let index = 0;
      params.projects.forEach(project => {
        options += "&project_id[" + index++ + "]=" + project;
      });
    }
    let headers = {};
    return ApiService.get(url, "processes" + options, headers);
  }
  store(data) {
    return ApiService.post(url + "/processes", data);
  }
  update(processId, data) {
    return ApiService.put(url + "/processes/" + processId, data);
  }

  uploadImage(processId, formData) {
    return ApiService.post(
      url + "/processes/" + processId + "/uploadImage",
      formData,
      {},
      true,
      false,
      ["Content-Type"]
    );
  }

  deleteImage(processId) {
    return ApiService.post(
      url + "/processes/" + processId + "/deleteImage",
      {}
    );
  }

  delete(id) {
    return ApiService.delete(url + "/processes/" + id);
  }
  run(id, data = {}, optionalHeaders = {}) {
    return ApiService.post(
      url + "/processes/" + id + "/run",
      data,
      optionalHeaders
    );
  }
  test(id, data) {
    return ApiService.post(url + "/processes/" + id + "/test", data);
  }
  abort(id) {
    return ApiService.post(url + "/processes/" + id + "/abort");
  }
  getFrequencies(params) {
    let options = "?page=" + params.page + "&perPage=" + params.size;
    return ApiService.get(url, "frequencies" + options);
  }
  generateFlowDescription(workflowId, locale) {
    ApiService.timeout = 60 * 1000;
    const queryParam = locale
      ? `?locale=${encodeURIComponent(locale)}`
      : "";
    let response = ApiService.get(
      url + `/workflows/${workflowId}/generateDescription${queryParam}`
    );
    ApiService.timeout =
      (process.env.VUE_APP_AXIOS_TIMEOUT_LIMIT_IN_SECONDS || 20) * 1000;
    return response;
  }
}
export default new ProcessManager();
